// extracted by mini-css-extract-plugin
export default {"card":"MainCard_card__5V-PJ","title":"MainCard_title__DOV40","paragraph":"MainCard_paragraph__NjlcB","menu":"MainCard_menu__pCOEC","menuLine":"MainCard_menuLine__9LI3S"};